const NextI18Next = require('next-i18next').default;

const otherLanguages = ['en', 'id']; // , 'sc'

const NextI18NextInstance = new NextI18Next({
  defaultLanguage: 'en',
  otherLanguages,
  fallbackLng: 'en',
  localeSubpaths: 'foreign',
  browserLanguageDetection: true,
  serverLanguageDetection: true,
  ignoreRoutes: ['/_next/', '/static/', '/career'],

  returnEmptyString: false,
  // allow keys to be phrases having `:`, `.`
  nsSeparator: false,
  keySeparator: false
});

NextI18NextInstance.i18n.languages = otherLanguages;

module.exports = NextI18NextInstance;
